import { FormControlLabel, Stack, Switch, Typography } from "@mui/material";

interface Props {
	generateInternal: boolean;
	onChangeInternal: (value: boolean) => void;
	generateExternal: boolean;
	onChangeExternal: (value: boolean) => void;
}

// Par de opções de follow-up automático, usado em todos os modais de lançamento do módulo de
// cobrança (Status, Ações, Responsável, Setor, Etapa) — pedido da operação pra poder escolher, a
// cada lançamento, se ele também sobe pro follow-up que sinistro/imobiliária enxergam.
export const FollowUpGenerationOptions = ({ generateInternal, onChangeInternal, generateExternal, onChangeExternal }: Props) => (
	<Stack direction="row" spacing={2} alignItems="center" flexWrap="wrap">
		<Typography variant="body2" color="text.secondary">
			Follow up:
		</Typography>

		<FormControlLabel
			control={<Switch size="small" checked={generateInternal} onChange={(e) => onChangeInternal(e.target.checked)} />}
			label="Interno"
			sx={{ mr: 0 }}
		/>

		<FormControlLabel
			control={<Switch size="small" checked={generateExternal} onChange={(e) => onChangeExternal(e.target.checked)} />}
			label="Externo"
			sx={{ mr: 0 }}
		/>
	</Stack>
);
